<template>
  <div id="EditSubCategoryAdmin">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>Update {{name}}</span>
            </h1>
            <!-- <div class="page-header-subtitle" v-if="role != 'all'">{{role}}</div> -->
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <div class="col-md-8">
                  <h3>Please provide {{client.subCategoryLabel}} name</h3>
                  <!-- Create form -->
                  <form @submit.prevent="updateSubCategory">
                    <div class="form-group">
                      <label for="name">
                        Select {{client.topCategoryLabel}}
                        <span class="text-danger">*</span>
                      </label>
                      <select @change="changeTopCategory($event)" class="form-control">
                        <option v-for="(cat, index) in categories" :key="index" :value="index" :selected="cat.uuid==subCategory.category.uuid ? 'selected' : '' ">{{cat.name}}</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label for="name">
                        {{client.subCategoryLabel}} name
                        <span class="text-danger">*</span>
                      </label>
                      <input type="text" v-model="name" class="form-control" />
                      <div class="invalid-feedback">
                        <span v-if="!$v.name.required">{{client.subCategoryLabel}} name is required.</span>
                        <span v-if="!$v.name.minLength">{{client.subCategoryLabel}} name must be at least {{ $v.name.$params.minLength.min }} letters.</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="name">{{client.subCategoryLabel}} description</label>
                      <textarea v-model="description" class="form-control" rows="3" />
                      <!-- <div class="invalid-feedback">
                          <span v-if="!$v.description.minLength">{{client.topCategoryLabel}} description must be at least {{ $v.name.$params.minLength.min }} letters.</span>
                      </div>-->
                    </div>
                    <button class="btn btn-danger btn-block">Update {{client.subCategoryLabel}}</button>
                  </form>
                  <!-- / Create form -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>


<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "EditSubCategoryAdmin",

  data() {
    return {
      name: "",
      description: "",
      categories: [],
      subCategory: {},
      facultyUUID: ""
    };
  },

  mounted() {
    let loading = this.$loading.show();
    axios.get(`/admin/sub-category/${this.$route.params.uuid}`).then(res => {
      this.name = res.data.subCategory.name;
      this.description = res.data.subCategory.description;
      this.facultyUUID = res.data.subCategory.category.uuid;
      this.subCategory = res.data.subCategory;
    });

    axios.get("/admin/categories").then(res => {
      this.categories = res.data.categories;
    });
    loading.hide();
  },

  methods: {
    updateSubCategory() {
      let loading = this.$loading.show();
      this.$v.$touch();
      if (this.$v.$invalid) {
        loading.hide();
        return;
      }
      //this.facultyUUID = this.subCategory.category.uuid;
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("topCategoryUUID", this.facultyUUID);
      formData.append("uuid", this.$route.params.uuid);

      axios.post("admin/sub-category/edit", formData).then(res => {
        if (res.data.status == "success") {
          //res.data.category.subCategories = [];
          //this.categories.push(res.data.category);
          this.$swal("", `${this.name} updated successfully`, "success");
          this.$router.push({ name: "SubCategoriesAdmin" });
        } else {
          this.$swal("", res.data.message, "error");
        }
        loading.hide();
      });
    },

    changeTopCategory(e) {
      this.facultyUUID = this.categories[e.target.value].uuid;
    }
  },

  computed: {
    client() {
      return this.$store.state.client;
    }
  },

  validations: {
    name: { required, minLength: minLength(2) }
    //description: { minLength: minLength(2) }
  }
};
</script>

